import { Platform, StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    alignItems: 'center',
    alignSelf: 'center',
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  checkIconContainer: {
    width: 38,
    height: 38,
    borderRadius: 100,
    backgroundColor: neutrals.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(Platform.OS === 'web' &&
      ({
        boxShadow: '1px 1px 3.8px rgba(0, 0, 0, 0.3)',
      } as any)),
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 40, // Posizionato sopra l'icona
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
